define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/dataPriv.js
// module id = 355
// module chunks = 1